import React from "react";

/**
 * Returns a component that forwards router props and sets auth portal `type`.
 * Keeps a single Login / RegistrationFlow / ResetPassword implementation.
 */
export const withAuthType = (Component, type) => {
  function AuthTypeRouteWrapper(props) {
    return <Component {...props} type={type} />;
  }

  const name = Component.displayName || Component.name || "Component";
  AuthTypeRouteWrapper.displayName = `WithAuthType(${name}, ${type})`;

  return AuthTypeRouteWrapper;
};
